import { jsx as e } from "react/jsx-runtime";
import { tv as t } from "../tailwind-variants.config.js";
const i = t({
  base: "jm-animate-spin jm-absolute",
  variants: {
    variant: {
      primary: "jm-fill-white",
      secondary: "jm-fill-jutro-new-blue-800",
      negative: "jm-fill-white",
      ghost: "jm-fill-jutro-new-blue-800",
      negativeGhost: "jm-fill-jutro-new-rose-600",
      secondaryNegative: "jm-fill-jutro-new-rose-800",
      dark: "jm-fill-jutro-new-warm-gray-800"
    },
    size: {
      condensed: "jm-w-4 jm-h-4",
      regular: "jm-w-6 jm-h-6",
      large: "jm-w-6 jm-h-6"
    },
    disabled: {
      true: ""
    }
  },
  defaultVariants: {
    variant: "primary",
    size: "regular",
    disabled: !1
  },
  compoundVariants: [
    {
      variant: "secondaryNegative",
      disabled: !0,
      class: "jm-fill-white"
    }
  ]
}), s = (a) => /* @__PURE__ */ e(
  "svg",
  {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: i(a),
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.5 3C7.52944 3 3.5 7.02944 3.5 12C3.5 16.9706 7.52944 21 12.5 21C17.4706 21 21.5 16.9706 21.5 12C21.5 11.0223 21.3445 10.0829 21.0575 9.20407C20.8861 8.67906 21.1728 8.1145 21.6978 7.94309C22.2228 7.77168 22.7874 8.05833 22.9588 8.58334C23.3103 9.66011 23.5 10.8089 23.5 12C23.5 18.0751 18.5751 23 12.5 23C6.42487 23 1.5 18.0751 1.5 12C1.5 5.92487 6.42487 1 12.5 1C13.6325 1 14.7268 1.17147 15.7573 1.49056C16.2849 1.65391 16.5802 2.21402 16.4168 2.74159C16.2535 3.26917 15.6934 3.56443 15.1658 3.40107C14.3246 3.14063 13.4297 3 12.5 3Z"
      }
    )
  }
);
export {
  s as ButtonLoader
};
//# sourceMappingURL=ButtonLoader.js.map
